import type { RefObject } from 'react';
import { Square, Volume2 } from 'lucide-react';
import { useLeituraEmVoz } from '../nucleo/leitura-voz';
import { Botao } from './base';

/**
 * U15 F4: botão "Ler em voz alta" (vira "Parar" enquanto lê) que lê o texto do elemento `alvo` com a voz do navegador.
 * Some quando o navegador não tem `speechSynthesis`. Parar ao fechar o painel é do `useLeituraEmVoz` (desmontar cancela).
 */
export function BotaoLerEmVoz({ alvo, idioma, rotuloLer, rotuloParar }: { alvo: RefObject<HTMLElement | null>; idioma: string | undefined; rotuloLer: string; rotuloParar: string }) {
  const voz = useLeituraEmVoz(idioma);
  if (!voz.suportado) return null;
  const texto = () => (alvo.current?.innerText || alvo.current?.textContent || '').replace(/\n{2,}/g, '\n');
  return (
    <Botao
      variante="secundario"
      tamanho="sm"
      data-ler-voz=""
      icone={voz.lendo ? <Square className="size-4" aria-hidden /> : <Volume2 className="size-4" aria-hidden />}
      onClick={() => (voz.lendo ? voz.parar() : voz.ler(texto()))}
    >
      {voz.lendo ? rotuloParar : rotuloLer}
    </Botao>
  );
}
